var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMouseIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mouseIcon_svg__clip0_103_110342)",
    fill: "#3F51B5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2 4.9l.5-.9c.6-1 1.8-1.3 2.8-.7 1.8 1.1 4.2.4 5.3-1.4.3-.4.1-1-.3-1.2-.4-.3-1-.1-1.2.3-.6 1-1.8 1.3-2.8.7-1.8-1.1-4.2-.4-5.3 1.4l-.6.9C10 2.4 5.8 3.8 3.8 7.2l-2.7 4.6C-1 15.5.2 20.3 4 22.4c3.8 2.1 8.5.9 10.7-2.8l2.7-4.6c1.9-3.4.9-7.8-2.2-10.1zM13.5 6c2.8 1.6 3.8 5.3 2.2 8.2l-10.3-6C7 5.3 10.7 4.3 13.5 6zM4.9 20.9c-2.8-1.7-3.8-5.3-2.2-8.2l1.7-3 10.3 6-1.7 3c-1.6 2.8-5.3 3.8-8.1 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8 9c.4.3 1 .1 1.2-.3l.6-1.1c.3-.4.1-1-.3-1.2-.4-.3-1-.1-1.2.3l-.6 1.1c-.3.3-.2.9.3 1.2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mouseIcon_svg__clip0_103_110342"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgMouseIcon;